export default __webpack_public_path__ + "static/media/Mercenary's Girdle of the Second Caste.b0ace9a4.jpg";